"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.methods = exports.selected = exports.isOpen = exports.initialState = void 0;
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/files");
exports.initialState = {
    isOpen: false,
    selected: false
};
exports.isOpen = monocle.Lens.fromProp('isOpen');
exports.selected = monocle.Lens.fromProp('selected');
exports.methods = {};
exports.methods[ActionTypes.TOGGLE_FILE_REPORT_MODAL] = (state, action) => exports.isOpen.modify((x) => !x)(state);
exports.methods[ActionTypes.TOGGLE_FILE_REPORT_SELECTION] = (state, action) => exports.selected.modify((x) => !x)(state);
const reducer = (state, action) => exports.methods[action.type](state, action);
exports.reducer = reducer;
//# sourceMappingURL=fileReport.js.map